module.exports = __webpack_public_path__ + "static/media/address.3e6df81d.svg";